import { createContext, useContext, useState, useEffect, ReactNode } from 'react';

interface BrandingConfig {
  appName: string;
  loginHeadline: string;
  loginSubtitle: string;
  appVersion: string;
  footerText: string;
}

interface BrandingContextType extends BrandingConfig {
  updateBranding: (config: Partial<BrandingConfig>) => void;
}

const defaultBranding: BrandingConfig = {
  appName: 'FUTURE READY MINDS',
  loginHeadline: 'Welcome Back, Lead Inspire Ultimate',
  loginSubtitle: 'Smart Viral Engine Link Generator System',
  appVersion: 'v25.0 Ultimate',
  footerText: '© 2025 By suluhhati.com',
};

const BrandingContext = createContext<BrandingContextType | undefined>(undefined);

export function BrandingProvider({ children }: { children: ReactNode }) {
  const [branding, setBranding] = useState<BrandingConfig>(() => ({
    appName: localStorage.getItem('app_name') || defaultBranding.appName,
    loginHeadline: localStorage.getItem('login_headline') || defaultBranding.loginHeadline,
    loginSubtitle: localStorage.getItem('login_subtitle') || defaultBranding.loginSubtitle,
    appVersion: localStorage.getItem('app_version') || defaultBranding.appVersion,
    footerText: localStorage.getItem('footer_text') || defaultBranding.footerText,
  }));

  useEffect(() => {
    document.title = branding.appName;
  }, [branding.appName]);

  const updateBranding = (config: Partial<BrandingConfig>) => {
    const newBranding = { ...branding, ...config };
    setBranding(newBranding);

    if (config.appName !== undefined) {
      localStorage.setItem('app_name', config.appName);
    }
    if (config.loginHeadline !== undefined) {
      localStorage.setItem('login_headline', config.loginHeadline);
    }
    if (config.loginSubtitle !== undefined) {
      localStorage.setItem('login_subtitle', config.loginSubtitle);
    }
    if (config.appVersion !== undefined) {
      localStorage.setItem('app_version', config.appVersion);
    }
    if (config.footerText !== undefined) {
      localStorage.setItem('footer_text', config.footerText);
    }
  };

  return (
    <BrandingContext.Provider value={{ ...branding, updateBranding }}>
      {children}
    </BrandingContext.Provider>
  );
}

export function useBranding() {
  const context = useContext(BrandingContext);
  if (!context) {
    throw new Error('useBranding must be used within BrandingProvider');
  }
  return context;
}
